export const STORAGE_PRODUCTS_CART = "productsCart";
export const TOKEN = "token";
export const siteURL = "https://marykay.sv";
export const jwtPart = "/wp-json/jwt-auth/v1/token";
export const woocomPart = "/wp-json/wc/v3/";
export const consumerKey = "ck_9a7f7f5767e7056636df07a59efee235ca542aec";
export const consumerSecret = "cs_49e9d5af78a060349ec8aec31e03866ac3ff4385";
export const cartlink = "/wp-json/cocart/v1/add-item";
export const JWT_KEY =")g}SPKO0P!K?zydHx4?h<-rks5G5^Iu~||&VSH@_(ulK qTS?kuP%HTlT00teA2r";
export const cartLinkVerCarrito = "/wp-json/cocart/v1/";